import { PredictionsRouter } from "./Router";

export const PredictionsModule = () => {
  return <PredictionsRouter />;
};
